const state = {
    action: null,
    detalhesCronograma: {},
    extratoFilter: null,
    filter: null,
    filterAgenda: null,
    idCronograma: null,
    limitObj: null,
    listAgenda: [],
    listCrono: [],
    listOperadora:[],
    listResponsavel:[],
    monitorCronograma: {
        qt_crono_aguardando_conclusao: 0,
        qt_crono_atrasado: 0,
        qt_crono_concluido: 0,
        qt_crono_critica: 0,
        qt_crono_envio: 0,
        qt_crono_nao_iniciados: 0,
        qt_crono_processamento: 0,
        qt_lote_aguardando_conclusao: 0,
        qt_lote_atrasado: 0,
        qt_lote_concluido: 0,
        qt_lote_critica_envio: 0,
        qt_lote_critica_validacao: 0,
        qt_lote_envio: 0,
        qt_lote_processamento_envio: 0,
        qt_lote_processamento_validacao: 0,
        qt_lote_sem_cronograma_critica: 0,
        qt_lote_sem_cronograma_ok: 0,
        vl_crono_aguardando_conclusao: 0,
        vl_crono_aguardando_conclusao_previsto: 0,
        vl_crono_atrasado: 0,
        vl_crono_concluido: 0,
        vl_crono_concluido_previsto: 0,
        vl_crono_critica: 0,
        vl_crono_envio: 0,
        vl_lote_sem_cronograma_critica: 0,
        vl_lote_sem_cronograma_ok: 0
    },
    prestadorCronograma: null,
    lotesList: [],
    selectedItem: {},
}

const actions = {
    async getAgenda({state}, opts) {
        let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
        //   state.filter = opts
          let obj = {
              url: '/api/proxy/postdata', 
              query: [
                {
                  Modulo: "Faturamento",
                  Acao: "getAgendaCronograma",
                  Payload: Object.assign({ grupo_economico: geco }, opts),
                },
              ],
          };
          state.filterAgenda = opts
          if(opts.prestador_id){
            let year = new Date().getFullYear()
            let obj = {
                dt_inicio: `${year}-01-01`,
                dt_fim: `${year+1}-12-31`,
                grupo_economico: geco,
                prestador_id: opts.prestador_id,
                referenceYear: year,
            }
            this.dispatch("common/getFeriados", obj)
          }
          await this.dispatch("request/doRequest", obj).then(response => {
              state.listAgenda = response && response.dados ? response && response.dados: []
          });
      },
  async getCronogramas({state}, opts) {
      opts.grupo_economico = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
      let obj = {
          url: '/api/proxy/postdata', 
          query: [
            {
              Modulo: "Faturamento",
              Acao: "getcronogramas",
              Payload: {...opts},
            },
          ],
      };
      let resp = await this.dispatch("request/doRequest", obj).then(response => {
          state.listCrono = response && response.sucesso? response.dados : []
          return response
      });
      return resp
  },
  async getDetalhesCronograma({state}, opts) {
      opts.grupo_economico = this.state.permissions.grupoEconomico
      let obj = {
          url: '/api/proxy/postdata', 
          query: [
            {
              Modulo: "Faturamento",
              Acao: "getDetalhesCronograma",
              Payload: opts
            }
          ]
      };
      let cronogradaData = await this.dispatch("request/doRequest", obj).then(response => {
          state.detalhesCronograma = response
          return response
      });
      return cronogradaData
  },
  async getFilter({state}, name){
    let filter = await this.dispatch("common/getCookie", name).then(response => {
        if(response && JSON.parse(response).grupo_economico == this.state.permissions.grupoEconomico){
            state.filter = response? JSON.parse(response) : state.filter
            return state.filter
        } else {
            state.filter = null
            return state.filter 
        }
    });
    return filter
  },
  async getExtratoFilter({state}, name){
    let extratofilter = await this.dispatch("common/getCookie", name).then(response => {
        if(response && JSON.parse(response).grupo_economico == this.state.permissions.grupoEconomico){
            state.extratofilter = response? JSON.parse(response) : state.extratofilter
            return state.extratofilter
        } else {
            state.extratofilter = null
            return state.extratofilter 
        }
    });
    return extratofilter
  },
  async getOperadoras({state}, opts){
    let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
    let obj = {
        url: '/api/proxy/postdata', 
        query: [{ 
            Modulo: "Portal",
            Acao: "getoperadoras",
            Payload: {
                grupo_economico: geco,
                ...opts
            },
            noLoader: true
      }]
    }
    let list = await this.dispatch("request/doRequest", obj).then(response => {
        state.listOperadora = response.dados
        return response.dados
    });
    return list
},
    async getResponsaveis({ state }, opts){
        let geco = opts.grupoEconomico? opts.grupoEconomico : this.state.permissions.grupoEconomico
        let obj = {
            url: '/api/proxy/postdata', 
            query: [{ 
                Modulo: "Portal",
                Acao: "getresponsaveis",
                Payload: {
                    grupo_economico: geco,
                    prestador_id: opts.prestador_id,
                    sem_bloqueados: opts.sem_bloqueados ? opts.sem_bloqueados : false
                },
            noLoader: true
        }]
        }
        await this.dispatch("request/doRequest", obj).then(response => {
            state.listResponsavel = response.dados
        });
    },

    async getmonitorcronogramas({state}, opts) {
        let payload = opts
        let obj = {
            query: [{ 
                Modulo: "Faturamento",
                Acao: "getmonitorcronogramas",
                Payload: payload
            }],
        }
        await this.dispatch("request/doRequest", obj).then(response => {
            if(response && response.cronoAtivos){
                state.monitorCronograma = response.cronoAtivos
            } else {
                let keys = Object.keys(state.monitorCronograma)
                keys.forEach(key => {
                    state.monitorCronograma[key] = 0
                })
            }
        })
    },
    async closeCronograma({state}, dadosCronograma) {
        if(state){
            let { grupo_economico, id, prestador_id, operadora_ans_id, login_prestador, status } = dadosCronograma
            let username_alteracao = this.state.userData.userData.UserName, user_id_alteracao = this.state.userData.userData.Id
            let obj = {
                query: [{ 
                    Modulo: "Faturamento",
                    Acao: "closecronograma",
                    Payload: { grupo_economico, id, prestador_id, operadora_ans_id, login_prestador, username_alteracao, user_id_alteracao, status }
                }],
            }
            let payload = await this.dispatch("request/doRequest", obj).then(response => {
                return response
            })
            return payload
        }
    },
    prestadorSelect({state}, prestadorId) {
        state.prestadorCronograma = prestadorId
    },
    setIdCronograma({state}, id) {
        state.idCronograma = id
    },
    getLotesAlocados({state}, payload) {
        let obj = {query:[{modulo: 'Faturamento', acao: 'getlotesalocados', payload}]}
        this.dispatch("request/doRequest",obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
            this.commit("hideLoader")
            return false
        }
        state.lotesList = response.dados
        })
    }
} 
const mutations = {
    selectItem(state, item) {
        state.selectedItem = item
    },
    setAction(state, action) {
        state.action = action
    },
    setFilter(state, opts) {
        if(opts){
            opts.grupo_economico = this.state.permissions.grupoEconomico
            this.dispatch('common/setCookie', ["cronogramaFilter", JSON.stringify(opts), 1])
            state.filter = opts
        }
    },
    setExtratoFilter(state, opts1) {
        if(opts1){
            opts1.grupo_economico = this.state.permissions.grupoEconomico
            this.dispatch('common/setCookie', [opts1.filtername, JSON.stringify(opts1), 1])
            state.extratofilter = opts1
        }
    },
}
export default {
    namespaced: true,
    root: true,
    actions,
    mutations,
    state,
};